import { render, staticRenderFns } from "./EventListingItem.vue?vue&type=template&id=145d8b16&"
import script from "./EventListingItem.vue?vue&type=script&lang=ts&"
export * from "./EventListingItem.vue?vue&type=script&lang=ts&"
import style0 from "./EventListingItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports